type TypeOfType =
  | 'string'
  | 'number'
  | 'bigint'
  | 'boolean'
  | 'symbol'
  | 'undefined'
  | 'object'
  | 'function';

export const betterTypeOf = (
  object: unknown
): TypeOfType | 'array' | 'date' | 'null' => {
  const simpleTypeOf = typeof object;
  if (simpleTypeOf !== 'object') return simpleTypeOf;
  if (Array.isArray(object)) return 'array';
  if (object === null) return 'null';
  if (object instanceof Date) return 'date';

  return simpleTypeOf;
};
